import { createFileRoute, redirect } from "@tanstack/react-router";
import AnomaliesPage from "@/pages/AnomaliesPage";
import { isAdminBuild } from "@/utils/isAdminBuild";

export const Route = createFileRoute(
  "/$leaid/_error-wrapper/admin/site-administration/anomalies"
)({
  beforeLoad: ({ context, params }) => {
    if (
      !isAdminBuild() ||
      params.leaid !== "0-" ||
      !context.hasRole("ADMIN")
    ) {
      throw redirect({ to: "/$leaid", params: { leaid: params.leaid } });
    }
  },
  component: AnomaliesPage,
});
